import addParametersToLink from 'utils/DOM/addParametersToLink'
import { findApplicant, findChildren, findSpouse } from '@hc-frontend/business'
import { getSPDomainData } from 'utils/snowplow/utils/getSPDomainData'

function getHealthSherpaQuotes(hcStorage, utmSource = '') {
  const {
    healthcareSession: sid,
    contact,
    location: { zip_code: zip_code, state_acronym: state },
    healthcareUserId: userId,
    source: src,
    members,
    life_event: qle,
    agent_id
  } = hcStorage

  const quotesHealthSherpa = `${require('core/constants/endpoints.ts').HEALTH_SHERPA}`

  const [enrollHealthSherpaURL, healthSherpaURLParams] = quotesHealthSherpa.split('?')

  /*
   ** Get members primary or spouse
   */
  const primaryApplicant = findApplicant(members)
  const spouseApplicant = findSpouse(members)
  const childApplicant = findChildren(members)
  const household_size = members.length

  /*
   ** Define the object of parameters by member primary or spouse to return applicants[primary][birth_date]=03/24/1987&applicants[primary][age]=34
   */
  const primaryParams = {}
  if (primaryApplicant) {
    primaryParams['applicants[primary][birth_date]'] = primaryApplicant.stringDOB
    primaryParams['applicants[primary][age]'] = primaryApplicant.age
    primaryParams['applicants[primary][age_format]'] = 'date'
    primaryParams['applicants[primary][gender]'] =
      primaryApplicant.gender === 'f' ? 'female' : 'male'
    primaryParams['applicants[primary][relationship]'] = 'primary'
    primaryParams['applicants[primary][smoker]'] = false
  }

  const spouseParams = {}
  if (spouseApplicant) {
    spouseParams['applicants[spouse][birth_date]'] = spouseApplicant.stringDOB
    spouseParams['applicants[spouse][age]'] = spouseApplicant.age
    spouseParams['applicants[spouse][age_format]'] = 'date'
    spouseParams['applicants[spouse][gender]'] =
      spouseApplicant.gender === 'f' ? 'female' : 'male'
    spouseParams['applicants[spouse][relationship]'] = 'spouse'
    spouseParams['applicants[spouse][smoker]'] = false
  }

  const childParams = {}
  if (childApplicant) {
    for (let child = 0; child < childApplicant.length; child++) {
      childParams['applicants[' + child + '][birth_date]'] =
        childApplicant[child].stringDOB
      childParams['applicants[' + child + '][age]'] = childApplicant[child].age
      childParams['applicants[' + child + '][age_format]'] = 'date'
      childParams['applicants[' + child + '][gender]'] =
        childApplicant[child].gender === 'f' ? 'female' : 'male'
      childParams['applicants[' + child + '][relationship]'] = 'dependents'
      childParams['applicants[' + child + '][smoker]'] = false
    }
  }
  const spDomainData = getSPDomainData()
  const utmCampaignValue = `${sid}:${spDomainData.domainUser}:${spDomainData.domainSession}`
  // Generate the URL to quotes HealthSherpa
  const enrollSherpaLink =
    enrollHealthSherpaURL +
    addParametersToLink(healthSherpaURLParams, {
      agent_id,
      zip_code,
      state,
      qle,
      household_size,
      apply_for_subsidy: true,
      utm_source: utmSource ? utmSource : 'enroll.pivothealth.com',
      household_income: '',
      utm_campaign: utmCampaignValue,
      src,
      ...primaryParams,
      ...spouseParams,
      ...childParams
    })

  return enrollSherpaLink
}

export default getHealthSherpaQuotes
